/* src/app/sidenav/sidenav-logo/sidenav-logo.component.scss */
div {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  padding: 15px 0;
}
div > img {
  height: 75%;
}
/*# sourceMappingURL=sidenav-logo.component.css.map */
